import { Component } from '@angular/core';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { NavParams } from '@ionic/angular';
import { ITalepler, OlaylarFilter, RezervasyonlarFilter } from '@models/dashboard';
import { CariHesapEkstresiFilter, DaireBorcAlacakFilter, IDaireBorcAlacak } from '@models/finance';
import { IUyeAracListesi } from '@models/operation';
import { ITesisModalKontrol } from '@shared/models';

@Component({
  template: `<ion-nav [root]="rootPage" [rootParams]="rootItem"></ion-nav>`,
})
export class RootModalComponent {
  rootPage: any;
  rootItem: {
    daireBorcAlacak: IDaireBorcAlacak,
    daireBorcAlacakFilter: DaireBorcAlacakFilter,
    talep: ITalepler,
    tesisModalKontrol: ITesisModalKontrol,
    rezervasyonFilter: RezervasyonlarFilter,
    olayFilter: OlaylarFilter,
    cariHesapEkstresiFilter: CariHesapEkstresiFilter,
    uyeAracListesi: IUyeAracListesi
  };

  constructor(
    public navParams: NavParams,
    private statusBar: StatusBar,
  ) { 
    this.rootItem = {
      daireBorcAlacak: navParams.data.daireBorcAlacak,
      daireBorcAlacakFilter: navParams.data.daireBorcAlacakFilter,
      talep: navParams.data.talep,
      tesisModalKontrol: navParams.data.tesisModalKontrol,
      rezervasyonFilter: navParams.data.rezervasyonFilter,
      olayFilter: navParams.data.olayFilter,
      cariHesapEkstresiFilter: navParams.data.cariHesapEkstresiFilter,
      uyeAracListesi: navParams.data.uyeAracListesi
    }
  }

  ionViewWillEnter() {
    this.statusBar.styleLightContent();
  }

  ionViewDidLeave() {
    this.statusBar.styleDefault();
  }
}
